import { Color } from "@starrez/starryui";
import styled from "styled-components";
import { IToggleButtonStyleProps } from ".";

export const Button = styled.button<IToggleButtonStyleProps>`
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-weight: bold!important;
    color: rgb(18, 55, 78);
    align-items: center;
    border: none;
    border-radius: 5px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: 30px;
    justify-content: center;
    transition: all ease-in-out 0.15s;
    vertical-align: top;
    white-space: nowrap;

    padding: 0 8px;

    &:active {
        transform: translateY(1px);
    }

    &:hover {
        ${Color.Grey.Lighter};
    }

    ${(props) => props.Checked && `
        background-color: rgb(18, 55, 78);
        color: #fff;
    `}

    &[disabled] {
        opacity: 0.4;
        pointer-events: none;
    }
`;

export const CaptionContainer = styled.span`
    line-height: 1.3em;
    vertical-align: middle;
    cursor: unset;
`;
